$(function(){
  var $window = $(window);
  var publish = MW.events.publish;

  var scrollEvents = {
    entries: {},
    firstScroll: function() {
      if(scrollEvents.scrolled) {
        return;
      }
      if($window.scrollTop() > 2) {
        publish("first_scroll");
        scrollEvents.scrolled = true;
        $window.off('scroll', scrollEvents.firstScroll);
      }
    },
    inEntry: $('article').attr('id'),

    entryEvents: Mobileweb.debounce(function() {
      MW.elements.$main.find('article.component').each(function(){
        var $article = $(this);
        var collapsed = $article.find('.entry-body').is('.collapsed');
        var entryId = $article[0].id;
        scrollEvents.entries[entryId] = scrollEvents.entries[entryId] || {};
        if(scrollEvents.inEntry === entryId && scrollEvents.entries[entryId].scrolledToStartOfEntry && scrollEvents.entries[entryId].scrolledToMidOfEntry && scrollEvents.entries[entryId].scrolledToEndOfEntry) {
          return;
        }
        var endOfEntry = $article.height();
        var midOfEntry = endOfEntry / 2;
        var viewPortHeight = $window.height();
        var scrolledTo = $window.scrollTop() + viewPortHeight - $article.offset().top;
        if(scrolledTo >= viewPortHeight/2 && !scrollEvents.entries[entryId].scrolledToStartOfEntry) {
          publish('start_of_entry', $article);
          scrollEvents.entries[entryId].scrolledToStartOfEntry = true;
        }
        if(!collapsed && scrolledTo >= midOfEntry && !scrollEvents.entries[entryId].scrolledToMidOfEntry) {
          publish('middle_of_entry', $article);
          scrollEvents.entries[entryId].scrolledToMidOfEntry = true;
        }
        if(!collapsed && scrolledTo >= endOfEntry && !scrollEvents.entries[entryId].scrolledToEndOfEntry) {
          publish('end_of_entry', $article);
          scrollEvents.entries[entryId].scrolledToEndOfEntry = true;
        }
        if(scrollEvents.inEntry !== entryId && scrolledTo>=viewPortHeight/2 && scrolledTo <= (endOfEntry+viewPortHeight/2)){
          publish('scroll_into_entry', $article);
          scrollEvents.inEntry = entryId;
        }
      });
    }, 100),

    entryInView: Mobileweb.debounce(function() {
      var $article = $('#entry-body').find('article');
      var entryIsVisible = $window.scrollTop() < $article.offset().top + $article.height();
      if(entryIsVisible && !scrollEvents.entryIsVisible) {
        scrollEvents.entryIsVisible = true;
        publish('entry_visible');
      }
      if(!entryIsVisible && scrollEvents.entryIsVisible) {
        scrollEvents.entryIsVisible = false;
        publish('entry_not_visible');
      }
    }, 100),

    alwaysOn: Mobileweb.throttle(function() {
      var $document = $(document);
      var scrolledToBottom = $document.scrollTop() + 600 > $document.height() - $window.height();
      if(scrolledToBottom) {
        publish('scroll_to_bottom');
      }
    }, 100)
  };

  MW.events.subscribe('init_dom_ready', function() {
    if(document.getElementById('entry-body')) {
      $window.on('scroll', scrollEvents.entryInView);
    }
    scrollEvents.alwaysOn();
    $window.on('scroll', scrollEvents.alwaysOn);
    $window.on('scroll', scrollEvents.firstScroll);
    $window.on('scroll', scrollEvents.entryEvents);
  });

});